
import {
     OperatorString,   Filters,
     ColumnFilter,
    OperatorDetail
  } from 'slickgrid-react';


export const TextOperators : OperatorDetail[]= [
    { operator: '' as OperatorString, desc: 'Zawiera' }, 
    { operator: '=' as OperatorString, desc: 'Jest równe' },
    { operator: '!=' as OperatorString, desc: 'Nie zawiera' },
    { operator: 'a*' as OperatorString, desc: 'Zaczyna się...' },
    { operator: '*z' as OperatorString, desc: 'Kończy się...' },
    // ...
] 




